import React, { useEffect, useState } from 'react';
import { getAllLectureLinks} from '../../services/LectureService';

import { Link } from "react-router-dom";
import "./datatable.scss"
import { DataGrid } from '@mui/x-data-grid';
import axiosInstance from '../../api/axios';

export const LectureList=()=> {
    const [lectures, setLectures] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchLectures = async () => {
        try {
            var data;
                data = await getAllLectureLinks();
            setLectures(data.data);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    };

    // Load lectures on component mount
    useEffect(() => {
        fetchLectures();
    }, []);
    
    const formatColumnData = (value) => {
        if (!value) return value;
    
        // Insert space before each uppercase letter
        let result = value.replace(/([a-z])([A-Z])/g, '$1 $2');
    
        // Capitalize the first letter
        result = result.charAt(0).toUpperCase() + result.slice(1);
    
        return result;
    };
    
 
    // Transform the data for a specific column
    const transformColumnData = (rows) => {
        return rows.map(row => ({
            ...row,
            type: formatColumnData(row.type) // Only format this column
        }));
    };

    const shareLectureLinks = async (row) => {
        try {
            const res = await axiosInstance.put(`/shareLectureLinks?id=${row.id}`);
            if (res.status === 200) {
            setLectures((prev) =>
                prev.map((lec) =>
                lec.id === row.id ? { ...lec, share_to_student: true } : lec
                )
            );
            }
        } catch (err) {
            console.error(err);
            alert("Failed to share lecture");
        }
        };

    // Transform the rows before rendering
    const transformedRows = transformColumnData(lectures);
    const columns = React.useMemo(
        () => [
            { field: 'name', headerName: 'Name', width: 170 },
            { field: 'sessions', headerName: 'Session', width: 120 },
            { field: 'batch', headerName: 'Batch', width: 120 },
            { field: 'report_type', headerName: 'Report Type', width: 150 },
            {
                field: 'presentation_recording_link',
                headerName: 'Presentation Link',
                width: 180,
                renderCell: (params) =>
                params.value ? (
                    <a
                    href={params.value}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: '#1976d2', textDecoration: 'underline' }}
                    >
                    Presentation 
                    </a>
                ) : (
                    <span style={{ color: '#999' }}>N/A</span>
                ),
            },
            {
                field: 'session_recording_link',
                headerName: 'Session Link',
                width: 180,
                renderCell: (params) =>
                params.value ? (
                    <a
                    href={params.value}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: '#1976d2', textDecoration: 'underline' }}
                    >
                    Session
                    </a>
                ) : (
                    <span style={{ color: '#999' }}>N/A</span>
                ),
            },
            {
                field: 'report_file_template_link',
                headerName: 'Report Template Link',
                width: 200,
                renderCell: (params) =>
                params.value ? (
                    <a
                    href={params.value}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: '#1976d2', textDecoration: 'underline' }}
                    >
                    Report
                    </a>
                ) : (
                    <span style={{ color: '#999' }}>N/A</span>
                ),
            },
            {
                field: 'rebuttal_report_template_link',
                headerName: 'Rebuttal Report Link',
                width: 200,
                renderCell: (params) =>
                params.value ? (
                    <a
                    href={params.value}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: '#1976d2', textDecoration: 'underline' }}
                    >
                    Rebuttal Report
                    </a>
                ) : (
                    <span style={{ color: '#999' }}>N/A</span>
                ),
            },
            {
                field: 'other_file_template_link',
                headerName: 'Other File Link',
                width: 200,
                renderCell: (params) =>
                params.value ? (
                    <a
                    href={params.value}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: '#1976d2', textDecoration: 'underline' }}
                    >
                    Other
                    </a>
                ) : (
                    <span style={{ color: '#999' }}>N/A</span>
                ),
            },
            ],
        []
    );

    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error.message}</p>;

    const actionColumn = [{ field: "action", headerName:"Action", width:200,
        renderCell:(params)=>{
            const { id } = params.row;
            return(
                <div className="cellAction">
                    <div className="editButton">
                    <button
                        disabled={params.row.share_to_student === true}
                        style={{
                        opacity: params.row.share_to_student ? 0.5 : 1,
                        cursor: params.row.share_to_student ? "not-allowed" : "pointer",
                        border: "none",
                        background: "none",
                        padding: 0
                        }}
                    >
                        <Link
                        to={`/lecturelinks/edit-lecturelink/${id}`}
                        style={{
                            textDecoration: "none",
                            color: params.row.share_to_student ? "gray" : "blue",
                            pointerEvents: params.row.share_to_student ? "none" : "auto"
                        }}
                        >
                        Edit
                        </Link>
                    </button>
                    </div>
                    <div>
                        <button
                            onClick={() => shareLectureLinks(params.row)}
                            disabled={params.row.share_to_student === true}
                            >
                            {params.row.share_to_student ? "Shared" : "Share"}
                            </button>
                    </div>
                </div>              
            );
        }
    }]

    return (
        <div className="datatable" >
            <div className="datatableTitle">
                <Link to="/lecturelinks/new" className="link" >
                    Add Lectures
                </Link>
            </div>
            <DataGrid 
            rows={transformedRows}
            columns={columns.concat(actionColumn)}
            initialState={{
                pagination: {
                paginationModel: { page: 0, pageSize: 10 },
                },
            }}
            pageSizeOptions={[5, 10]}
            //checkboxSelection
            />
        </div>
    );
}
